import {
  apiField,
  constructFromApiData,
  getApiPostData,
} from "../ResourceItemMetadata";
import { ResourceItem } from "../ResourceItem";
import { createListResource } from "../../list";

export class Directory extends ResourceItem {
  @apiField()
  name!: string;

  children!: Directory[];
  parent: Directory | null = null;

  constructor(data?: any) {
    super(data);

    if (data) {
      constructFromApiData(this, data);
      this.parent = data.parent || null;

      this.children = data.children.map(
        (child: any) => new Directory({ ...child, parent: this }),
      );
    }
  }

  getPostData() {
    return {
      ...super.getPostData(),
      ...getApiPostData(this),
    };
  }
}

export const directoryResource = createListResource(
  "iam/directories/",
  (data) => new Directory(data),
);
